import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { CFHttpClient } from '../shared/cf-http-client';
import { UserSession } from '../shared/user-session';
import { MemberAccountDetailsResponse } from './member-account-details';
import {environment} from '../../environments/environment';

//const memberAccountDetailsUrl = '/mas/sec/getMemberAccountDetails.json';
const memberAccountDetailsUrl = environment.serviceSecuredURLs.getMemberAccountDetailsURL;

@Injectable()
export class MemberAccountDetailsResolver implements Resolve<MemberAccountDetailsResponse> {
  constructor(
    private http: CFHttpClient,
    private router: Router,
    private userSession: UserSession
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<MemberAccountDetailsResponse> {
    if (!this.userSession.getCurrentAccountId()) {
      return this.http.get(memberAccountDetailsUrl).catch(response => {
        this.router.navigate(['/error'], { skipLocationChange: true, queryParams: response.error });
        return null;
      });
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/member-account-details-resolver.service.ts